import { SVGIconComponent } from './types';

export const Pause: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 30 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <path
        id="Shape"
        fill="currentColor"
        fillRule="nonzero"
        d="M14.973 0c8.257 0 14.976 6.715 14.976 14.973 0 8.257-6.719 14.976-14.976 14.976C6.715 29.95 0 23.23 0 14.973 0 6.715 6.715 0 14.973 0Zm0 2.602c-6.82.003-12.368 5.55-12.368 12.37 0 6.821 5.547 12.372 12.368 12.372 6.82 0 12.37-5.551 12.37-12.371 0-6.743-5.429-12.246-12.144-12.368Zm-2.996 7.91a1.5 1.5 0 0 1 1.5 1.5v5.996a1.503 1.503 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5v-5.996a1.5 1.5 0 0 1 1.5-1.5Zm6.007 0a1.5 1.5 0 0 1 1.5 1.5v5.996c0 .824-.672 1.5-1.496 1.5a1.501 1.501 0 0 1-1.504-1.5v-5.996a1.5 1.5 0 0 1 1.5-1.5Zm0 0"
      />
    </g>
  </svg>
);
